import { useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

import useApi from '../../hooks/useApi'
import { useCurrentUser } from '../../hooks/useCurrentUser'

// Owner or event admin: generates a new check-in token, which invalidates
// the current QR code and any printed flyers. The backend rejects everyone
// else with a 422.
export default function RegenerateCheckInToken({ event, setRefresh }) {
  const { t } = useTranslation()
  const { regenerateCheckInToken } = useApi()
  const { currentUser } = useCurrentUser()

  const [showConfirm, setShowConfirm] = useState(false)
  const [busy, setBusy] = useState(false)
  const [failed, setFailed] = useState(false)

  const isOwner = !!currentUser?.id && currentUser.id === event?.user?.id
  if (!isOwner && !event?.current_user_admin) {
    return null
  }

  const regenerate = async () => {
    if (busy) return
    setBusy(true)
    setFailed(false)
    const response = await regenerateCheckInToken({ eventId: event.id })
    setBusy(false)
    if (response?.status === 200) {
      setShowConfirm(false)
      setRefresh(+new Date())
    } else {
      setFailed(true)
    }
  }

  return (
    <>
      <Button
        variant="link"
        className="p-0 mt-1 text-decoration-none small"
        onClick={() => setShowConfirm(true)}
      >
        {t('event.checkInQr.regenerate_button')}
      </Button>
      <Modal show={showConfirm} onHide={() => setShowConfirm(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{t('event.checkInQr.regenerate_title')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {t('event.checkInQr.regenerate_details')}
          {failed && (
            <p className="text-danger mt-2 mb-0">
              {t('event.checkInQr.regenerate_error')}
            </p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowConfirm(false)}>
            {t('buttons.cancel')}
          </Button>
          <Button variant="primary" disabled={busy} onClick={regenerate}>
            {t('event.checkInQr.regenerate_confirm')}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
